import { render, staticRenderFns } from "./BizInsuranceDataModal.vue?vue&type=template&id=4631d15e&"
import script from "./BizInsuranceDataModal.vue?vue&type=script&lang=js&"
export * from "./BizInsuranceDataModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports